// Top-bar layout from the saved menu config (used by the Navbar and the admin menu preview).
// The menu editor fully controls order and grouping; the top bar fits NAV_CAP links for
// every user and any extra saved top-bar links overflow into Explore.
export const NAV_CAP = 7;

export function buildNav(cfg, customPages = [], cap = NAV_CAP) {
  const primary = cfg.filter((l) => l.group === "primary").map((l) => ({ to: l.to, label: l.label }));
  const primaryLinks = primary.slice(0, cap);
  const overflow = primary.slice(cap).map((l) => ({ ...l, overflow: true }));
  const exploreLinks = [
    ...overflow,
    ...cfg.filter((l) => l.group === "explore").map((l) => ({ to: l.to, label: l.label })),
    ...customPages.map((p) => ({ to: `/p/${p.slug}`, label: p.nav_label || p.title, page: true })),
  ];
  return { primaryLinks, exploreLinks };
}
